export const EDITABLE_TERM_SET_METADATA_FIELDS = [
  'DocumentClass',
  'DocumentClassContent',
] as const;
